enum BackButtonHandlerPriority {
    HOME = -1,
    SIGN_IN = 0,
    ADD_VOCABULARY = 1,
    ADD_DEFINITION = 2,
}

export default BackButtonHandlerPriority;
